<template>

	<transition name="slide-fade">

		<span v-if="loaded ==='true'">

			<main class="col-xs-12 npd" v-if="page.better_featured_image!= null ">
				<img v-bind:src="page.better_featured_image.media_details.sizes['1440x446'].source_url" alt="" width="100%">
				<hr>
			</main>
			<section class="col-xs-12 info-locutor">
				<h2 v-html="page.title.rendered"></h2>
				<div class="container">
					<div class="row" v-html="page.content.rendered">

					</div>
				</div>
			</section>

			<template v-if="loaded_childrens =='true'" v-for="subpage in page_childrens">

					<page_formulario v-if="subpage.acf.template=='formulario'" :pagina="subpage"></page_formulario>


					<page_iconos v-if="subpage.acf.template=='iconos'" class="valor__item" :pagina="subpage"></page_iconos>


					<page_historia v-if="subpage.acf.template=='historia'" class="contenido-anho" :pagina="subpage"></page_historia>

					<page_pioneros v-if="subpage.acf.template=='pioneros'" class="col-xs-12 npd pioneros__item" :pagina="subpage"></page_pioneros>

					<page_opiniones v-if="subpage.acf.template=='opiniones'" class="item laopinion" :pagina="subpage"></page_opiniones>

					<page_mapa v-if="subpage.acf.template=='mapa'" class="col-xs-12 npd flex-centermid mapa" :pagina="subpage"></page_mapa>


			</template>

			<versiculosdeldia></versiculosdeldia>
		</span>

	</transition>

</template>

<script>
export default {
	mounted: function() {
		this.getPage();
	},
	data() {
		return {
			page: {},
			page_childrens: {},
			loaded: 'false',
			loaded_childrens: 'false',
			pageTitle: ''
		};
	},
	methods: {
		getPage: function() {
			const vm = this;
			vm.loaded = 'false';

			vm.$http.get( 'wp/v2/pages', {
				params: { slug: vm.$route.params.name }
			} )
			.then( ( res ) => {

				vm.page = res.data[ 0 ];
				vm.loaded = 'true';
				vm.pageTitle = vm.page.title.rendered;
				this.getChildrens(vm.page.id)
				vm.$store.commit( 'rtChangeTitle', vm.pageTitle );
				vm.$nextTick(function(){
					init_attach();

				});
			} )
			.catch( ( res ) => {
				//console.log( `Something went wrong : ${ res }` );
			} );
		},
		getChildrens: function(_parent){
			// console.log(_parent);
			const vm = this;
			vm.loaded_childrens = 'false';
			vm.$http.get( 'wp/v2/pages', {
				params: { parent: _parent, per_page: 100, orderby:'menu_order', order:'asc' }
			} )
			.then( ( res ) => {

				var _data=res.data;

				_data.forEach(function(item,key){
					if(key==0){
						_data[key].acf.prev_tmpl='';
					} else {
						_data[key].acf.prev_tmpl=_data[(key-1)].acf.template;
					}

					if(key==(_data.length - 1)){
						_data[key].acf.next_tmpl='';
					} else {
						_data[key].acf.next_tmpl=_data[(key+1)].acf.template;
					}

				});

				vm.page_childrens = _data;
				window._subpaginas= vm.page_childrens;
				vm.$nextTick(function(){
					jQuery(jQuery('.valor__item')).wrapAll('<section class="col-xs-12 block laradio"><div class="container"><div class="row"><div class="col-xs-12 npd block valor">');
					jQuery(jQuery('.contenido-anho')).wrapAll('<section class="col-xs-12 npd"><section class="col-xs-12 historia"> <div class="container"><div class="row"><div class="wrap-anos">');


					var _li='';
					jQuery('.contenido-anho').each(function(){
						var self=this;
						_li+='<li><a href="#'+jQuery(self).attr('id')+'">'+jQuery(self).attr('anio')+'</a></li>';
					});
					var _htmlanios='<section class="col-xs-12 anhos"><div class="container"><div class="row"><ul class="nav__anhos">'+_li+'</ul></div></div></section>';
					jQuery('section.historia').after(_htmlanios);

					jQuery(jQuery('.pioneros__item')).wrapAll('<section class="col-xs-12 block pioneros"><div class="container"><div class="row">');


					jQuery(jQuery('.laopinion')).wrapAll('<section class="col-xs-12 block bgg testimonios"><div id="asdamyCarousel" class="carousel slide" data-ride="carousel" data-interval="false"><div class="container"><div class="row"><div class="carousel-inner">');

					jQuery('.laopinion:first').addClass('active');

					init_attach();
				});
				vm.loaded_childrens = 'true';

			} )
			.catch( ( res ) => {
				//console.log( `Something went wrong : ${ res }` );
			} );
		}
	},
	watch: {
		'$route'( to, from ) {
			// react to route changes...
			this.getPage();
		}
	}
};
</script>



// WEBPACK FOOTER //
// page.vue?72277c42